import { Box, Button, Typography } from "@mui/material";
import { ParsedUrlQuery } from "querystring";

const ReferralStateAlert = ({ context }: { context: ParsedUrlQuery }) => {
  const { service, ...rest } = context;
  const keys = Object.keys(rest).filter((q) => q.toLowerCase() !== "state");
  const qs = keys.map((key) => `${key}=${rest[key]}`).join("&");

  return (
    <Box
      sx={{
        display: "inline-flex",
        p: 2,
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        borderRadius: 1,
        border: 1,
        // border: "1px solid #FFB0A8",
        // background: "#FFD8D5",
        margin: "0 auto !important",
        fontFamily: "ABCDiaTypeRegular",
        maxWidth: { xs: "380px", lg: "650px" },
      }}
    >
      <Typography
        color="warning"
        align="center"
        fontSize="16px"
        sx={{ lineHeight: "22.4px", letterSpacing: "-0.16px" }}
      >
        Unfortunately the provider who referred you cannot service your state of
        residency. We are happy to match you with another Thrivelab provider.
        Please confirm if you would like to proceed
      </Typography>
      <Button
        variant="contained"
        color="primary"
        href={service && service?.length > 0 ? `/?${qs}` : undefined}
      >
        Find Another Provider
      </Button>
    </Box>
  );
};

export default ReferralStateAlert;
